import Vue from "vue";
import router from "@/router";
import store from "@/store";
import userService from "@/store/services/profile-service";
import { VueAuthenticate } from "vue-authenticate";

import axios from "axios";
import VueAxios from "vue-axios";
import { th } from "date-fns/locale";
Vue.use(VueAxios, axios);

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: "jwt",
  tokenPath: "jwt",
  loginUrl: "/auth/local",
  registerUrl: "/register",
});

export default {
  state: {
    isAuthenticated:
      localStorage.getItem("vue-authenticate.vueauth_jwt") !== null,
    namespaced: true,
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
  },

  actions: {
    login(context, payload) {
      return vueAuth
        .login(payload.user, payload.requestOptions)
        .then(async (response) => {
          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated(),
          });

          try {
            await store.dispatch("users/get", response.data.user.id);
            let user = store.getters["users/user"];

            //  let user = await userService.get(response.data.user.id);

            //  this.$store.getters["users/list"];
            console.log("ROL:", user.role.id);

            if (user.role != undefined && user.role.id == 3) {
              router.push({ path: "/dashboard" });
            } else {
              return vueAuth.logout().then((response) => {
                context.commit("isAuthenticated", {
                  isAuthenticated: false,
                });
              });
            }
          } catch (error) {
            console.log("HE CAZADO EL ERROR");
            return vueAuth.logout().then((response) => {
              context.commit("isAuthenticated", {
                isAuthenticated: false,
              });
            });
          }

          /*   try {
            var me = await store.dispatch("profile/me");
            if (me.role.id == 3) {
              router.push({ path: "/dashboard" });
            }
          } catch (error) {
            console.log(error);
            return vueAuth.logout().then((response) => {
              context.commit("isAuthenticated", {
                isAuthenticated: vueAuth.isAuthenticated(),
              });
              // router.push({ name: "Login" });
            });
          } */
        });
    },

    register(context, payload) {
      return vueAuth
        .register(payload.user, payload.requestOptions)
        .then((response) => {
          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated(),
          });
          router.push({ path: "/dashboard" });
        });
    },

    logout(context, payload) {
      return vueAuth
        .logout()
        .then((response) => {
          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated(),
          });
          router.push({ name: "Login" });
        })
        .catch(function (e) {
          context.commit("isAuthenticated", {
            isAuthenticated: false,
          });
          router.push({ name: "Login" });
        });
    },
  },
};
